import React, { useRef, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { getOrders } from "services"
import { Spinner, } from "components"
import KtOrderNoteCard from "./KtOrderNoteCard"
import { isOrderForThisUser, socketConnection } from "utils"
import classes from "./index.module.scss"

const KtOrderNotes = props => {
  const { selectedTableId, tableDetails } = props

  const [t] = useTranslation()

  const [tableNotConfirmedOrders, setTableNotConfirmedOrders] = useState(null)

  const unmount = useRef(false)

  const handleTableNotConfirmedOrderChanges = (jsonMessage) => {
    const message = JSON.parse(jsonMessage)

    const event = message.key

    if (event === "orderCreated") {
      const order = message.value.order

      const validOrderTable =
        order.tableNumber === tableDetails.tableNumber

      if (!validOrderTable) return

      if (!isOrderForThisUser(order)) return

      setTableNotConfirmedOrders(prev => [order, ...prev])

      return
    }

    if (event === "orderUpdated") {
      const order = message.value.order

      const validOrderTable =
        order.tableNumber === tableDetails.tableNumber

      if (!validOrderTable) return

      if (!isOrderForThisUser(order)) return

      setTableNotConfirmedOrders(prev =>
        prev.map(o => o._id === order._id ? order : o)
      )

      return
    }

    if (event === "orderDeleted") {
      const order = message.value

      const validOrderTable =
        order.tableNumber === tableDetails.tableNumber

      if (!validOrderTable) return

      setTableNotConfirmedOrders(prev =>
        prev.filter(o => o._id !== order._id)
      )

      return
    }

    if (event === "orderConfirmed") {
      const order = message.value.order

      const validOrderTable =
        order.tableNumber === tableDetails.tableNumber

      if (!validOrderTable) return

      if (!isOrderForThisUser(order)) return

      setTableNotConfirmedOrders(prev =>
        prev.filter(o => o._id !== order._id)
      )

      return
    }
  }

  const getTableNotConfirmedOrder = async () => {
    setTableNotConfirmedOrders(null)

    try {
      const response =
        await getOrders({
          skip: 0,
          limit: 30,
          sortBy: "newstOrder",
          statusMultiple: ["notConfirmed"],
          tableNumber: tableDetails.tableNumber
        })

      if (unmount.current) return

      setTableNotConfirmedOrders([...response])
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getTableNotConfirmedOrder()
  }, [selectedTableId])

  useEffect(() => {
    unmount.current = false

    const socket = socketConnection.getSocket()

    socket.on(
      "basicEmit",
      handleTableNotConfirmedOrderChanges
    )

    return () => {
      socket.removeListener(
        "basicEmit",
        handleTableNotConfirmedOrderChanges
      )

      unmount.current = true
    }
  }, [])

  return (
    <div className={classes["container"]}>
      {tableNotConfirmedOrders !== null
        ?
        tableNotConfirmedOrders.length !== 0
          ?
          tableNotConfirmedOrders.map(tableNotConfirmedOrder =>

            <KtOrderNoteCard
              key={tableNotConfirmedOrder._id}
              tableNotConfirmedOrder={tableNotConfirmedOrder}
              setTableNotConfirmedOrders={setTableNotConfirmedOrders}
            />
          )
          :
          <div className={classes["center"]}>
            {t("هیج_سفارشی_ثبت_نشده")}
          </div>
        :
        <div className={classes["center"]}>
          <Spinner
            size={20}
            color="var(--color-primary)"
          />
        </div>
      }
    </div>
  )
}

export default KtOrderNotes